export const bookingLinkService = {
  linkDomainData: (linkString, defaultDomain) => {
    if (!linkString || !defaultDomain) { return {} }

    const linkDomainHost = new URL(linkString).hostname
    const defaultDomainHost = new URL(defaultDomain).hostname

    const isCustomDomain = (linkDomainHost !== defaultDomainHost) && (linkDomainHost.startsWith('calendly.'))
    const linkDomain = isCustomDomain ? linkDomainHost : defaultDomainHost

    return { isCustomDomain, linkDomain }
  }
}
